import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import TriggeredProduction from '@/roc/effects/Production/TriggeredProduction';
import SynergyEffect from '@/roc/wonders/base/SynergyEffect';
import EffectAmount from "@/roc/effects/EffectAmount";
class Synergy extends EffectAmount {
    __kind;
    __wonderId;
    constructor(calc, amount, kind = null, wonderId = null) {
        super(calc, amount);
        this.__kind = kind || 0;
        this.__wonderId = wonderId;
    }
    get kind() {
        return this.__kind;
    }
    get wonderId() {
        return this.__wonderId;
    }
    withKind(kind) {
        return new Synergy(this.__calc, this.__amount, kind, this.__wonderId);
    }
    withWonderId(wonderId) {
        return new Synergy(this.__calc, this.__amount, this.__kind, wonderId);
    }
    toEffect(effect) {
        let eff = null;
        if (effect instanceof PassiveAura) {
            eff = effect.clone(null, this.clone());
        }
        else if (effect instanceof PassiveProduction) {
            eff = effect.clone(null, effect.output.withAmount(this.clone()));
        }
        else if (effect instanceof TriggeredProduction) {
            eff = effect.clone(this.clone());
        }
        if (eff) {
            return new SynergyEffect(eff, this);
        }
        throw new Error('Unsupported effect type');
    }
}
export default Synergy;
